import { getApiUrl } from './api';
import * as legacy from './legacy';
import { Config } from './model';
import { ClientType, isTerminated, MessageType, parseUcMessages, ucMessage } from './uc-messaging';
import { redirectToLogin } from '.';

type MessageHandler = (message: Message) => Promise<void>
let connections: number = 0

const onConnected = (config: Config, mediaToFetch: string[], mobility:boolean) => (e: Event) => {
  connections = 0
  const offset = new Date().getTimezoneOffset() * -1
  const ws = e.target as WebSocket
  const message = ucMessage(config.clientId, ClientType.Teams, config.serverName, config.extension, '0', mediaToFetch.join(','), (offset * 60).toString(), mobility ? '1' : '0')
  console.info('ws sending : ' + message)
  ws.send(message)
}

const onReceived = (ws: WebSocket, clientId: string, onMessage: MessageHandler) => {
  let lastMessage = ''
  return ({ data }: MessageEvent) => {
    const message = lastMessage + data

    if (!isTerminated(message)) {
      console.warn('push', 'incomplete message', message)
      lastMessage = message
      return
    }

    const log: Log = { message }
    if (process.env.NODE_ENV === 'development') {
      pushLog.push(log)
    }

    lastMessage = ''
    for (const records of parseUcMessages(message)) {
      const fields = records[0]
      if (fields.length === 0) continue
      const type = parseInt(fields.shift()!)

      if (type === 1718) {
        // this is websocket internal keep alive.
        const pong = ucMessage('PONG', ClientType.Teams, '', '', '0', '', '0', '0')
        ws.send(pong)
        return
      }

      const id = fields.shift()
      if (id !== clientId) {
        console.warn('push', 'ClientId mistmatch', id, clientId)
      }

      log.type = MessageType[type]
      log.records = records
      onMessage({ type, records })
    }

    legacy.incomingEvent(message)
  }
}

interface Message {
  type: MessageType
  records: string[][]
}

function resolveUrl(url: string) {
  const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
  return `${proto}//${window.location.host}${getApiUrl(url, false)}`
}

interface Log {
  message: string
  type?: string
  records?: string[][]
}

const pushLog: Log[] = [];
if (process.env.NODE_ENV === 'development') { (window as any).pushLog = pushLog }

export default function pushUpdates(config: Config, mobility: boolean, handler: MessageHandler, mediaToFetch: string[], onClose: () => void) {
  const ws = new WebSocket(resolveUrl('/Handlers/WebSocket.ashx'))
  ws.addEventListener('open', onConnected(config, mediaToFetch, mobility))
  ws.addEventListener('message', onReceived(ws, config.clientId, onMessage))
  ws.addEventListener('error', e => console.error('push', e))
  ws.addEventListener('close', e => {
    connections += 1
    console.warn('push', e)
    if (connections <= 10) {
      onClose()
    } else {
      //legacy.monitorAlert(() => redirectToLogin())
      redirectToLogin()
    }
  })

  async function onMessage(message: Message) {
    const { type, records } = message

    console.log('push', MessageType[type] || type, ...records)

    try {
      await handler(message)
    } catch (e) {
      console.error('push', e)
    }
  }

  if (process.env.NODE_ENV === 'development') {
    (pushLog as any).msg = (data: string) => ws.dispatchEvent(new MessageEvent('message', { data }))
  }

  return () => ws.close()
}
